<template>
  <v-alert v-if="store.error" type="error" density="compact">
    <v-row>
      <v-col class="grow">
        Fehler: {{store.error.message}}
      </v-col>
      <v-col class="shrink">
        <v-btn @click="store.fetch(kundenNr)" size="small" :loading="store.loading">Erneut versuchen</v-btn>
      </v-col>
    </v-row>
  </v-alert>
  <v-select
    v-else
    :variant="!showLabel ? 'solo' : undefined"
    :density="!showLabel ? 'compact' : 'default'"
    label="Ansprechpartner"
    hide-details
    class="mt-3 mb-2"
    v-model="internalValue"
    :item-title="contactLabel"
    item-value="AnsprechpartnerNr"
    :items="store.data"
    :loading="store.loading"
    placeholder="--- Ansprechpartner wählen ---"
    :return-object="false"
    :rules="rules"
    clearable
    :disabled="disabled"
  />
</template>

<script lang="ts" setup>
import {useContactSelectStore} from '@/store/contactSelect';
import Loading from '@/components/Loading.vue';
import {computed} from 'vue';
import Contact from '@/model/Contact';
const store = useContactSelectStore();
const props = defineProps<{
    modelValue?: Array<{AnsprechpartnerNr?: number}>
    showLabel?: boolean
    disabled?: boolean
    kundenNr: number,
    rules?: Array<(value: any) => true | string>
}>();

const emit = defineEmits({'update:modelValue': (data: Array<{AnsprechpartnerNr?: number}>) => Array.isArray(data)});

store.fetch(props.kundenNr).catch(console.error);

const internalValue = computed({
  get(): number | undefined {
    if (!props.modelValue?.length) return undefined;
    const temp = props.modelValue[0].AnsprechpartnerNr;
    console.log(`internalValue: ${typeof temp} ${temp}`);
    return temp ? Number(temp) : temp;
  },
  set(newVal: number | undefined) {
    if (newVal != undefined && newVal >= 0) {
      emit('update:modelValue', [{AnsprechpartnerNr: newVal}]);
      return;
    } else {
      emit('update:modelValue', []);
      return;
    }
  },
});

const contactLabel = (item: Contact) => {
  console.log('contactLabel: ', item);
  // @ts-expect-error
  if (item === 0) {
    return 'ohne Ansprechpartner';
  }
  if (item.Vorname == '') {
    return item.Nachname;
  }
  return item.Nachname + ', ' + item.Vorname;
};

defineExpose({
  store,
  internalValue,
  fetch,
  props,
  Loading,
  Error,
  contactLabel,
});
</script>
